// libraries.
import { useState } from "react";

// hooks.
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";

// store.
import { useRulesSlice } from "@store/apiSlices/incentiveRules/slices/rules";

// styles.
import { StyledTimeline } from "../styles";

// components.
import { ColorLegend } from "./ColorLegend";
import { EditStepModal } from "./EditStepModal";

// interfaces.
import { IncentiveStep } from "../rulesData";

const categoryLabels: Record<IncentiveStep["category"], string> = {
  bono: "Bono",
  descuento: "Descuento",
  remate: "Remate",
  transicion: "Transición",
};

const formatDayRange = (dayRange: [number, number | null]): string => {
  const [from, to] = dayRange;
  if (to === null) return `Día ${from}+`;
  return `Día ${from} – ${to}`;
};

export const IncentiveRouteTab = () => {
  const { country } = useUserProfile();
  const resolvedCountry = country || "CO";
  const { incentiveStepsCO, incentiveStepsMX } = useRulesSlice();
  const steps = resolvedCountry === "MX" ? incentiveStepsMX : incentiveStepsCO;

  const [editingStep, setEditingStep] = useState<IncentiveStep | null>(null);

  const countryLabel = resolvedCountry === "MX" ? "México" : "Colombia";

  return (
    <>
      <div className="d-flex flex-column gap-3">
        <ColorLegend />

        <p className="text-muted mb-1">
          Ruta de Incentivos Default para <strong>{countryLabel}</strong>. Los
          ajustes se aplican progresivamente según los días en Inventario Full.
        </p>

        <StyledTimeline>
          <div className="timeline-line" />

          {steps.map((step) => (
            <div key={step.id} className="timeline-step">
              <div className={`timeline-dot ${step.category}`}>
                <div className={`timeline-dot-inner ${step.category}`} />
              </div>

              <div className="step-card">
                <div className="step-header">
                  <div className="d-flex align-items-center gap-2">
                    <span className="step-name">{step.name}</span>
                    <span className="step-day-range">
                      {formatDayRange(step.dayRange)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className={`step-modifies ${step.modifiesPrice ? "yes" : "no"}`}
                    >
                      {step.modifiesPrice
                        ? "Modifica precios"
                        : "No modifica precios"}
                    </span>
                    <span className={`step-badge ${step.category}`}>
                      {step.adjustment}
                    </span>
                    <span className={`step-badge ${step.category}`}>
                      {categoryLabels[step.category]}
                    </span>
                    <button
                      className="step-edit-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditingStep(step);
                      }}
                      title="Editar paso"
                      disabled
                      style={{ opacity: 0, pointerEvents: "none" }}
                    >
                      ✏️
                    </button>
                  </div>
                </div>

                <p className="step-description mb-0">{step.description}</p>
              </div>
            </div>
          ))}
        </StyledTimeline>
      </div>

      <EditStepModal
        step={editingStep}
        country={resolvedCountry}
        onClose={() => setEditingStep(null)}
      />
    </>
  );
};
